export { default } from './CreateNewPost';
